import { Component, OnInit } from '@angular/core';
import { IAuditDto } from '../../models/IAuditDto';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css']
})
export class BaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  // Audit
  get Audit(): IAuditDto {
    let a1: any = localStorage.getItem('ssk_Audit');

    if (a1 == 'undefined'
      || a1 == undefined
      || a1 == null) {
      return {} as IAuditDto;
    }

    let a: IAuditDto = JSON.parse(a1);

    if (a == undefined || a == null) {
      return {} as IAuditDto;
    }

    return a;
  }

  set Audit(value: IAuditDto) {
    console.log('AuditDto', value);
    localStorage.setItem('ssk_Audit', JSON.stringify(value));
  }
      
  // AuditProfileId
  get AuditProfileId(): string | null {
    // Pseudocode:
    // - Read 'ssk_AuditProfileId' from localStorage
    // - If not present or invalid => return null
    // - Attempt JSON.parse (setter stores JSON-stringified values)
    // - If parsed is a non-empty string => return it
    // - If parse fails (legacy plain string), return raw
    const raw = localStorage.getItem('ssk_AuditProfileId');

    if (raw === null || raw === '' || raw === 'undefined' || raw === 'null') {
      return null;
    }

    try {
      const parsed: unknown = JSON.parse(raw);
      return typeof parsed === 'string' && parsed !== '' ? parsed : null;
    } catch {
      return raw;
    }
  }

  set AuditProfileId(value: string | null) {
    console.log('AuditProfileId', value);
    localStorage.setItem('ssk_AuditProfileId', JSON.stringify(value));
  }

  // PreviewDataTableSchema
  get PreviewDataTableSchema(): string {
    let a1: any = localStorage.getItem('ssk_PreviewDataTableSchema');

    if (a1 == 'undefined'
      || a1 == undefined
      || a1 == null
      || a1 == '') {
      return 'NOT SET';
    }

    return a1;
  }

  set PreviewDataTableSchema(value: string) {
    localStorage.setItem('ssk_PreviewDataTableSchema', value);
  }

  // PreviewDataTableName
  get PreviewDataTableName(): string {
    let a1: any = localStorage.getItem('ssk_PreviewDataTableName');

    if (a1 == 'undefined'
      || a1 == undefined
      || a1 == null
      || a1 == '') {
      return 'NOT SET';
    }

    return a1;
  }

  set PreviewDataTableName(value: string) {
    localStorage.setItem('ssk_PreviewDataTableName', value);
  }
}
